import { render, staticRenderFns } from "./ManageUserPassword.vue?vue&type=template&id=2570c2d0"
import script from "./ManageUserPassword.vue?vue&type=script&lang=js"
export * from "./ManageUserPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports